import { ApplicationWithDetails } from '../../../types';
import { iSpringInstruction_eng } from './iSpringInstruction';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const iSpring_eng: ApplicationWithDetails = {
	id: `11EE4351F01FFBBEA55A4652C9FA8BC6`,
	name: `Dodo Learning. Integration`,
	description: `An indispensable assistant for employee training.`,
	descriptionLong: `Dodo Learning is an indispensable assistant in employee training that is always at hand.
The platform helps simplify the employee training process, making it more visual, interesting and fun. Includes interactive courses, training programs, information about important changes and major news in training.\n\nFor your employees to start training, connect your departments to the Dodo learning platform.`,
	logoUrl: `https://cdn.dodostatic.net/static/marketplace/ispring/logo-1`,
	sliders: [
		// eslint-disable-next-line sonarjs/no-duplicate-string
		`https://cdn.dodostatic.net/static/marketplace/ispring/slider-1-en`,
		`https://cdn.dodostatic.net/static/marketplace/ispring/slider-2-en`,
		`https://cdn.dodostatic.net/static/marketplace/ispring/slider-3-en`,
		`https://cdn.dodostatic.net/static/marketplace/ispring/slider-4-en`,
		`https://cdn.dodostatic.net/static/marketplace/ispring/slider-5-en`,
	],
	logoBgr: `https://cdn.dodostatic.net/static/marketplace/ispring/logo-bgr`,
	conceptions: [`Dodo Pizza`, `Drinkit`, `Doner42`],
	webSiteUrl: `https://www.ispring.ru/`,
	supportUrl: null,
	redirectUrl: `https://dodois.effit.ru/partners/sign-in`,
	contactEmail: `podorojnik@dodois.io`,
	supportEmail: ``,
	type: `Web`,
	categories: [`Employees`, `Learning`, `Growth`],
	countries: [`Russia`, `Kazakhstan`, `Belarus`],
	languages: [`Русский`, `English`],
	price: `Free`,
	version: `1.0`,
	developer: `LLC «Richmedia»`,
	plans: null,
	instructions: iSpringInstruction_eng,
	details: null,
	knowledgeBase: null,
	isExternal: true,
	showInstruction: false,
	versionHistory: null,
	goToApp: true,
};
